<template>
  <div>
    <v-toolbar flat>
      <v-icon color="success" class="add-icon" medium>mdi-plus</v-icon>
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
    </v-toolbar>
    <formWrapper :validator="$v.form">
      <v-form @submit.prevent="handleSubmit">
        <v-row>
          <v-col
            v-if="$route.name === 'edit_product'"
            cols="12"
            md="6"
            class="mx-auto"
          >
            <locale-select v-model="locale" @change="changeLocale" />
          </v-col>
          <v-col cols="12">
            <span class="headings gray--text">{{
              $t("labels.required_image")
            }}</span>
            <new-image-upload
              class="file-upload__image"
              :imgUrl="form.main_image ? form.main_image.path : ''"
              :imgId="form.main_image ? form.main_image.id : ''"
              @fileSelected="handleMainImage"
              :maxSize="main_image_Size"
            />
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="name" attribute="fields.name">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.name"
                  outlined
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="label_id" attribute="fields.label_id">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  outlined
                  v-bind="attrs"
                  v-on="listeners"
                  :items="labels"
                  item-text="name"
                  item-value="id"
                  :loading="labelLoading"
                  v-model.number="form.label_id"
                ></v-select>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="price" attribute="fields.price">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  type="number"
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.price"
                  outlined
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="qty" attribute="fields.qty">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  type="number"
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.qty"
                  outlined
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="description" attribute="fields.description">
              <template slot-scope="{ attrs, listeners }">
                <v-textarea
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.description"
                  outlined
                  no-resize
                  rows="8"
                >
                </v-textarea>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <form-group name="components" attribute="fields.components">
              <template slot-scope="{ attrs, listeners }">
                <v-combobox
                  v-bind="attrs"
                  v-on="listeners"
                  outlined
                  v-model="form.components"
                  hide-selected
                  :label="$t('labels.add_component')"
                  multiple
                  persistent-hint
                  :hint="$t('labels.product_hint')"
                  small-chips
                  :error-messages="setServerErorrs()"
                  @change="resetServerError"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <kbd>enter</kbd>
                          <span>{{ $t("labels.create_title") }}</span>
                          <kbd>backSpace</kbd>
                          <span>{{ $t("labels.remove_text") }}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <section class="file-upload__gallery mt-2">
              <multi-image-upload
                class="file-upload__gallery--upload"
                :maxSize="photo_size"
                @fileSelected="handleMultiPhotos"
                @handle_delete_image="handleDelteImag"
                :imgsUrl="form.media"
              />
            </section>
          </v-col>
        </v-row>
        <v-btn
          type="submit"
          :loading="loading"
          :disabled="$v.form.$invalid"
          class="primary"
        >
          <span>{{ $t("button.save") }}</span>
          <v-icon small right>mdi-send</v-icon>
        </v-btn>
      </v-form>
    </formWrapper>
  </div>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  minValue
} from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate";
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";
export default {
  name: "FormActionProduct",
  data() {
    return {
      form: {
        name: "",
        label_id: "",
        price: "",
        main_image: "",
        description: "",
        qty: "",
        components: [],
        photos: []
      },

      labels: [],
      main_image_Size: 2.48,
      photo_size: 1.24,
      locale: this.locale,
      loading: false,
      labelLoading: true
    };
  },
  computed: {
    formTitle() {
      if (this.$route.params.slug) {
        return this.$t("headings.edit_product");
      } else {
        return this.$t("headings.create_product");
      }
    },
    serverErrors() {
      return this.$store.getters.serverErrors;
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      label_id: {
        required
      },
      description: {
        required,
        minLength: minLength(3),
        maxWords: maxWords(100)
      },
      price: {
        required,
        numeric
      },

      main_image: {
        required
      },
      qty: {
        required,
        numeric,
        minValue: minValue(1)
      },
      components: {
        required
      }
    }
  },
  methods: {
    resetServerError() {
      if (this.serverErrors) {
        this.$store.dispatch("ClearServerErrors");
      }
    },
    setServerErorrs() {
      if (this.serverErrors) {
        for (let key in this.serverErrors) {
          const index = key.match(/\d+/g).join("");

          for (let error of this.serverErrors[`components.${index}`]) {
            const replacedErrorName = error.replace(
              `components.${index}`,
              this.form.components[index]
            );

            return replacedErrorName;
          }
        }
      }
    },
    handleGetLables() {
      IndexData({ reqName: "labels" }).then(res => {
        const { data } = res.data;
        this.labels = data;
        this.labelLoading = false;
      });
    },
    handleMainImage(img) {
      this.form.main_image = img.file;
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },
    handleMultiPhotos(photos) {
      this.form.photos = photos;
    },
    handleDelteImag(index) {
      this.form.media.splice(index, 1);
    },
    handleSubmit() {
      this.loading = true;
      const formData = new FormData();
      if (this.$route.name === "edit_product") {
        delete this.form.main_image;
      }
      Object.keys(this.form).forEach(key => {
        if (
          key !== "photos" &&
          key !== "media" &&
          key !== "components" &&
          key !== "label" &&
          key !== "date"
        ) {
          formData.append(key, this.form[key]);
        }
      });
      this.form.components.forEach(component =>
        formData.append("components[]", component)
      );
      this.form["photos"].forEach(photo => formData.append("photos[]", photo));
      formData.append("locale", this.locale);

      if (this.$route.name === "create_product") {
        // in case create
        this.createProduct(formData);
      } else {
        // in case edit
        formData.append("_method", "put");
        this.editProduct(formData);
      }
    },
    editProduct(data) {
      const { slug } = this.$route.params;
      UpdateData({ reqName: "products", data, param: slug })
        .then(() => this.$router.push({ name: "products" }))
        .finally(() => (this.loading = false));
    },
    async createProduct(data) {
      try {
        await StoreData({ reqName: "products", data });
        this.$router.push({ name: "products" });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleShowData(locale) {
      const { slug } = this.$route.params;

      if (slug) {
        ShowData({ reqName: "products", param: slug, locale }).then(res => {
          const { product } = res.data;

          this.form = {
            ...this.form,
            label_id: product.label.id,
            ...product
          };
          console.log(product);
        });
      }
    }
  },
  watch: {
    $route: {
      handler() {
        this.handleGetLables();
        this.handleShowData();
      },
      immediate: true
    }
  }
};
</script>
